export default "__VITE_ASSET__ff6c61d9__"